import { createFileRoute } from '@tanstack/react-router'

// Leaf route — Group container is mounted by the parent route.tsx layout.
// `planId` is read by the container via useParams({ strict: false }).
export const Route = createFileRoute(
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/'
)({
  component: () => null
})
